export default "__VITE_ASSET__2fa6b0b1__"